import { ADD_TRANSLATIONS } from './consts';
import { getActiveLanguage } from '../../utils/languages';

const initialState = {
	list: {
		translations: {},
	},
	isInitialized: false,
	activeLanguage: getActiveLanguage(),
};

export const translationsReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case ADD_TRANSLATIONS:
			return {
				...state,
				list: payload.data,
				isInitialized: payload.isInitialized,
			};

		default:
			return state;
	}
};
